export const convertFilterIcon = (
  headerFilter: { [key: string]: number },
  key: string
): string => {
  let label = "";
  switch (headerFilter[key]) {
    case 1:
      label = "▲";
      break;
    case 2:
      label = "▼";
      break;
  }
  return label;
};

export const changeHeaderFilter = (
  headerFilter: { [key: string]: number },
  setSortedData: React.Dispatch<React.SetStateAction<any[]>>,
  key: string,
  compareFn: (a: any, b: any) => number,
  searchRows: any[]
) => {
  for (let name in headerFilter) {
    if (name !== key) {
      headerFilter[name] = 0;
    }
  }

  if (!headerFilter[key]) {
    headerFilter[key] = 0;
  }

  if (headerFilter[key] < 2) {
    headerFilter[key] = headerFilter[key] + 1;
  } else {
    headerFilter[key] = 0;
  }

  let tmp: any[] = searchRows;
  switch (headerFilter[key]) {
    case 1:
      tmp = [...searchRows].sort(compareFn);
      break;
    case 2:
      tmp = [...searchRows].sort(compareFn).reverse();
      break;
  }
  setSortedData(tmp);
};
